import React from "react";
import "./APCRDAProposedLayout.css";
import siteLayout from "../../assets/SiteLayout.png"
// import Table from "../../assets/Table.png"
import SkylineTable1 from "../../assets/Skyline_Table_Phase 1.png"
import SkylineTable2 from "../../assets/Skyline_Table_Phase 2.png"


const APCRDAProposedLayout = () => {
  return (
    <>
      <div className="container-fluid py-3 APCRDAProposedLayoutContainer">
        <div className="container">
          <p className="APCRDAProposedLayout-title">APCRDA Proposed Layout</p>
          <div>
            <img
            //   src={`https://cdn.builder.io/api/v1/image/assets%2F7fa683a22a9c42d7a697097e1847f1c9%2F70e61c7c645d4b1ea59455ad4c05c81f`}
            src={siteLayout}        
              alt="APCRDAProposedLayoutImg"
              className="image-fluid w-100 h-auto"
            />
          </div>

          <div className="row justify-content-center align-items-center py-4">
            <div className="col-auto">
              <div className="d-flex justify-content-around text-center g-4">
                <div
                  className="box"
                  style={{ backgroundColor: "#F1AECD" }}
                ></div>
                <p className="BoxName">Amenities</p>
                <div
                  className="box"
                  style={{ backgroundColor: "#C7D7E3" }}
                ></div>
                <p className="BoxName">Phase I</p>
                <div
                  className="box"
                  style={{ backgroundColor: "#D5E7D7" }}
                ></div>
                <p className="BoxName">Phase II</p>
                <div
                  className="box"
                  style={{ backgroundColor: "#F4B885" }}
                ></div>
                <p className="BoxName">Mortgage</p>
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-sm-6">
              <img
                // src={`https://cdn.builder.io/api/v1/image/assets%2F7fa683a22a9c42d7a697097e1847f1c9%2F7e2279d4f8924333a43d52679cfb5869`}
                src={SkylineTable1}
                alt="table1"
                className="image-fluid w-100 h-auto"
              />
            </div>
            <div className="col-sm-6">
              <img
                // src={`https://cdn.builder.io/api/v1/image/assets%2F7fa683a22a9c42d7a697097e1847f1c9%2Fa5034029cee64799b5a0152eeae5d798`}
                src={SkylineTable2}
                alt="table1"
                className="image-fluid w-100 h-auto apcrda2"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default APCRDAProposedLayout;
